// extracted by mini-css-extract-plugin
module.exports = {"menuWrapper":"historical-menu-bar_menuWrapper__2wS9W","groupBtn":"historical-menu-bar_groupBtn__29uuN"};